<template>
    <div class="rounded-3xl md:rounded-b-none bg-error max-md:-ml-5 p-5 pl-10 mb-7 md:mb-0 md:pb-8 md:mt-8 mx-auto md:text-center relative"
        style="width: 100%">

        <img src="~/assets/images/icons/icona_regali.png" class="w-14 md:mx-auto md:mt-[-50px]">

        <div class="py-9">
          <h3 class="text-2xl font-bold py-5">
            Un Regalo Solidale<br />
            vale doppio!
          </h3>

          <p class="md:mx-auto md:w-96 pb-3">
            Un regalo solidale è <strong>un dono che fa bene due volte</strong>: a te e all’organizzazione che te lo
            offre.
          </p>
          <NuxtLink to="/regalo-solidale"
                    class="btn btn-block btn-natale rounded-full drop-shadow-xl md:btn-wide flex justify-between mx-auto md:mb-8">
            <span>Scopri i nostri consigli</span>
            <i class="sa sa-round-arrow-right-up line2"></i>
          </NuxtLink>
        </div>
    </div>
    <div class="pb-8 md:pb-0 px-5 md:px-0">
      <div class="rounded-3xl md:rounded-none bg-white p-6 md:px-0 md:pt-0  text-center text-secondary mx-auto"
           id="areyou">
        <img src="~/assets/images/icons/icona_albero.png" alt="sei un'azienda?"
             class="w-14 mx-auto md:mt-[-55px] relative md:pb-9" style="z-index:10;">
        <h3 class="text-xl font-bold py-5 md:pt-9">Sei un Ente non profit?</h3>

        <p class="md:w-4/12 mx-auto font-thin pb-8">
          Partecipa al Market Solidale di Natale, inserisci i tuoi regali e le modalità per sostenere il tuo ente.
        </p>
        <div class="md:pb-9">
          <a href="https://italianonprofit.it/iscriviti/?n24=1" target="_blank" class="btn btn-block btn-error rounded-full drop-shadow-xl md:btn-wide flex justify-between mx-auto">
            <span>Iscrivi la tua organizzazione</span>
            <i class="sa sa-round-arrow-right-up line2"></i>
          </a>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
.btn-natale {
    background-color: #25494F;
    color: #FADFDB;
    border-color: #25494F;
    --icon-color: #FADFDB;

    &:hover {
        background-color: #213F45;
        border-color: #213F45;
    }
}
#giftbox{
    height:50px;
    clip-path: ellipse(50% 9% at 50% 100%);
}
.dividerfil{width: 200%;
    height: 50px;
    border-radius: 100%;
    top: 90%;
    left: -50%;
    right: 0;
    position: relative;}
#areyou{
    position:relative;

    &::before{

        @media (min-width: 768px){
          content: "";
            position: relative;
            top:-20px;
            clip-path: ellipse(50% 100% at 50% 100%);
            height: 20px;
            background-color: white;
            display: block;
            width: 100%;
            padding: 0;  
        }
        
    }
}
</style>